/**
 * ピックアップバナー スライダー
 *
 * 機能:
 * - 自動再生（PC: 5秒、スマホ: 3秒）
 * - 無限ループスライド
 * - スワイプ対応
 * - レスポンシブ（PC: 4枚、タブレット: 2枚、スマホ: 1枚）
 */

document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('.pickup-banner');
  if (!section) return;

  const track = section.querySelector('.pickup-banner__track');
  const originalSlides = Array.from(section.querySelectorAll('.pickup-banner__slide'));
  const dots = section.querySelectorAll('.pickup-banner__dot');
  const prevBtn = section.querySelector('.pickup-banner__arrow--prev');
  const nextBtn = section.querySelector('.pickup-banner__arrow--next');

  const totalSlides = originalSlides.length;
  if (totalSlides === 0) return;

  // 表示枚数以下の場合はスライダー無効化（矢印・ドット非表示、自動再生なし）
  function getVisibleSlidesCount() {
    if (window.innerWidth >= 990) return 2;
    if (window.innerWidth >= 750) return 2;
    return 1;
  }

  if (totalSlides <= getVisibleSlidesCount()) {
    if (prevBtn) prevBtn.style.display = 'none';
    if (nextBtn) nextBtn.style.display = 'none';
    const dotsContainer = section.querySelector('.pickup-banner__dots');
    if (dotsContainer) dotsContainer.style.display = 'none';
    track.style.display = 'flex';
    track.style.justifyContent = 'center';
    return;
  }

  let currentIndex = 0;
  let autoplayInterval;
  let isTransitioning = false;

  function getVisibleSlides() {
    if (window.innerWidth >= 990) return 2;
    if (window.innerWidth >= 750) return 2;
    return 1;
  }

  function getGap() {
    if (window.innerWidth >= 990) return 8;
    if (window.innerWidth >= 750) return 12;
    return 0;
  }

  function getAutoplaySpeed() {
    return window.innerWidth >= 990 ? 5000 : 3000;
  }

  function getSlideWidth() {
    const firstSlide = track.querySelector('.pickup-banner__slide');
    return firstSlide ? firstSlide.offsetWidth : 0;
  }

  function setupInfiniteLoop() {
    const visibleSlides = getVisibleSlides();

    track.querySelectorAll('.pickup-banner__slide--clone').forEach(clone => clone.remove());

    for (let i = 0; i < visibleSlides; i++) {
      const cloneEnd = originalSlides[i % totalSlides].cloneNode(true);
      cloneEnd.classList.add('pickup-banner__slide--clone');
      track.appendChild(cloneEnd);
    }

    for (let i = visibleSlides - 1; i >= 0; i--) {
      const cloneStart = originalSlides[(totalSlides - 1 - i) % totalSlides].cloneNode(true);
      cloneStart.classList.add('pickup-banner__slide--clone');
      track.insertBefore(cloneStart, track.firstChild);
    }
  }

  function updateSlider(animate = true) {
    const visibleSlides = getVisibleSlides();
    const slideWidth = getSlideWidth();
    const gap = getGap();

    const offset = (currentIndex + visibleSlides) * (slideWidth + gap);

    if (animate) {
      track.style.transition = 'transform 0.4s linear';
    } else {
      track.style.transition = 'none';
    }

    track.style.transform = `translateX(-${offset}px)`;

    dots.forEach((dot, index) => {
      const normalizedIndex = ((currentIndex % totalSlides) + totalSlides) % totalSlides;
      dot.classList.toggle('is-active', index === normalizedIndex);
    });
  }

  function goToSlide(index, animate = true) {
    if (isTransitioning) return;
    currentIndex = index;
    updateSlider(animate);
  }

  function nextSlide() {
    if (isTransitioning) return;
    isTransitioning = true;
    currentIndex++;
    updateSlider(true);
  }

  function prevSlide() {
    if (isTransitioning) return;
    isTransitioning = true;
    currentIndex--;
    updateSlider(true);
  }

  function handleTransitionEnd() {
    const visibleSlides = getVisibleSlides();

    if (currentIndex >= totalSlides) {
      currentIndex = 0;
      updateSlider(false);
    } else if (currentIndex < 0) {
      currentIndex = totalSlides - 1;
      updateSlider(false);
    }

    isTransitioning = false;
  }

  function startAutoplay() {
    stopAutoplay();
    autoplayInterval = setInterval(nextSlide, getAutoplaySpeed());
  }

  function stopAutoplay() {
    if (autoplayInterval) {
      clearInterval(autoplayInterval);
    }
  }

  track.addEventListener('transitionend', handleTransitionEnd);

  prevBtn.addEventListener('click', function() {
    prevSlide();
    startAutoplay();
  });

  nextBtn.addEventListener('click', function() {
    nextSlide();
    startAutoplay();
  });

  dots.forEach((dot, index) => {
    dot.addEventListener('click', function() {
      if (isTransitioning) return;
      const normalizedCurrent = ((currentIndex % totalSlides) + totalSlides) % totalSlides;
      const diff = index - normalizedCurrent;
      currentIndex += diff;
      updateSlider(true);
      startAutoplay();
    });
  });

  section.addEventListener('mouseenter', stopAutoplay);
  section.addEventListener('mouseleave', startAutoplay);

  let touchStartX = 0;
  let touchEndX = 0;

  track.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].screenX;
    stopAutoplay();
  }, { passive: true });

  track.addEventListener('touchend', function(e) {
    touchEndX = e.changedTouches[0].screenX;
    const diff = touchStartX - touchEndX;

    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        nextSlide();
      } else {
        prevSlide();
      }
    }
    startAutoplay();
  }, { passive: true });

  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      setupInfiniteLoop();
      currentIndex = 0;
      updateSlider(false);
      startAutoplay();
    }, 150);
  });

  setupInfiniteLoop();
  updateSlider(false);
  startAutoplay();
});
